import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { SupportedChainId, SupportedChains } from '@packet/constants/AppSupportChains';

interface ChainState {
  chainId: SupportedChainId;
  setChainId: (chainId: SupportedChainId) => void;
  getCurrentChain: () => (typeof SupportedChains)[number];
}

export const useChainStore = create<ChainState>()(
  persist(
    (set, get) => ({
      chainId: SupportedChains[0].id,

      setChainId: (chainId: SupportedChainId) => {
        set({ chainId });
      },

      getCurrentChain: () => {
        const { chainId } = get();
        return SupportedChains.find((chain) => chain.id === chainId) || SupportedChains[0];
      },
    }),
    {
      name: 'audit-chain-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        chainId: state.chainId,
      }),
    },
  ),
);
